<template>
  <div class="container-fluid">
    <div>
      <div class="row card">
        <div class="card-body" id="prof">
          <div class="d-flex align-items-center justify-content-between">
            <div class="search-zone mb-3">
              <div class="input-icon input-icon-right">
                <input
                  v-model="search"
                  type="text"
                  placeholder="Recherche ..."
                  class="w-100 form-control basic_datatable_search_query"
                />
                <span><i class="flaticon2-search-1 icon-md"></i></span>
              </div>
            </div>

            <button class="btn btn-primary" @click="exportToExcel">
              Excel
            </button>
          </div>
          <table v-if="datasLoaded" class="table">
            <thead style="background-color: #003667; color: white">
              <tr class="text-center">
                <td># Agresso</td>
                <td>Matricule RH</td>
                <td>Enseignant permanent</td>
                <td>Catégorie</td>
                <td>Collège</td>
                <td>Établissement</td>
                <td>Année universitaire</td>
                <td>VH statutaire</td>
                <td>VH FC</td>
                <td>VH de la décharge</td>
                <td>VH déchargé</td>
                <td>VH planifié</td>
                <td>VH réalisé</td>
                <td style="width: 150px">
                  <select
                    style="background-color: #003667; color: white"
                    @change="filtrer()"
                    v-model="filterDepass"
                    placeholder="Etat"
                    class="form-control mr-2"
                  >
                    <option value="" disabled>Dépassement</option>
                    <option value="1">Oui</option>
                    <option value="0">Non</option>
                  </select>
                </td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              <tr
                class="text-center"
                v-for="data in datas"
                :key="`data_${data.professeur.agresso}`"
              >
                <td>#{{ data.professeur.agresso }}</td>
                <td>#{{ data.professeur.matricule_rh }}</td>
                <td>
                  {{ data.professeur.nom }}
                  {{ data.professeur.prenom }}
                </td>
                <td>{{ data.professeur.categorie_prof }}</td>
                <td>
                  {{
                    data.decharge != null
                      ? data.decharge.etablissement.college.nom
                      : "--"
                  }}
                </td>
                <td>
                  {{
                    data.decharge != null
                      ? data.decharge.etablissement.nom
                      : "--"
                  }}
                </td>
                <td>
                  {{
                    data.decharge != null
                      ? data.decharge.annee_universitaire
                      : "--"
                  }}
                </td>
                <td>
                  {{
                    data.professeur.vh_statutaire +
                    data.professeur.vh_statutaire_encad
                  }}
                  H
                </td>
                <td>
                  {{ data.VhFc > 0 ? data.VhFc + " H" : "--" }}
                </td>
                <td>
                  {{
                    data.decharge != null
                      ? data.decharge.nb_heures + " H"
                      : "--"
                  }}
                </td>
                <td>
                  {{ data.vh_decharger }}
                  H
                </td>
                <td>{{ data.vh_planifie }} H</td>
                <td>{{ data.vh_realise }} H</td>
                <td>
                  <a
                    v-if="data.depassement == 0"
                    href="#"
                    class="btn btn-icon btn-sm raduis-50 yes-icon-cercle"
                  >
                    <i class="icon-xl la la-check"></i>
                  </a>
                  <a v-else href="#">
                    <i
                      class="fa fa-exclamation-triangle"
                      style="color: #ffd43b"
                    ></i>
                  </a>

                  <!-- <a
                    v-else
                    href="#"
                    class="btn btn-icon btn-sm raduis-50 no-icon-cercle"
                  >
                    <i class="icon-xl la la-times"></i>
                  </a> -->
                </td>
                <td>
                  <button
                    @click="showVH(data.professeur.id)"
                    class="btn btn-outline-primary btn-sm btn-icon mr-2"
                  >
                    <i class="fa fa-eye"></i>
                  </button>
                </td>
              </tr>
              <tr v-show="!datas.length">
                <td colspan="14" class="text-center">
                  Aucune décharge trouvé.
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="14">
                  <jw-pagination
                    :items="allDatas"
                    @changePage="onChangePageprof"
                  ></jw-pagination>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

  <script>
import { VclTable } from "vue-content-loading";
import * as XLSX from "xlsx";
import moment from "moment";

export default {
  props: {
    admin: {},
  },
  components: {
    VclTable,
  },
  data() {
    return {
      allDatas: [],
      prof: [],
      datas: [],
      prof: {},
      vacataire: [],
      professeur: {},
      profLoaded: null,
      datasLoaded: null,
      keyword: null,
      nb_heures_old: null,
      nb_heures: null,
      type: "",
      commentaire: null,
      profNotFound: false,
      disableValideBtn: false,
      search: null,
      filterDepass: "",
      currentDateTime: moment().format("YYYY-MM-DD"),

      config: {
        headers: {
          Authorization: "Bearer " + this.admin.api_token,
        },
      },
    };
  },
  watch: {
    search(after, before) {
      if (this.search != "") {
        this.searchVH();
      } else {
        this.reloadprofs();
      }
    },
  },
  methods: {
    exportToExcel() {
      // Map data: remove 'email', and map 'role' to 'role.name'
      const exportData = this.allDatas.map((data) => ({
        Agresso: data.professeur.agresso,
        "Matricule RH": data.professeur.matricule_rh,
        "Enseignant permanent":
          data.professeur.nom + " " + data.professeur.prenom,
        Catégorie: data.professeur.categorie_prof,
        Collège:
          data.decharge != null
            ? data.decharge.etablissement.college.nom
            : "--",
        Établissement:
          data.decharge != null ? data.decharge.etablissement.nom : "--",
        "Année universitaire":
          data.decharge != null ? data.decharge.annee_universitaire : "--",
        "VH statutaire":
          data.decharge != null ? data.professeur.vh_statutaire : "--",
        "VH FC": data.VhFc != null ? data.VhFc : "--",
        "VH statutaire encadrement":
          data.decharge != null ? data.professeur.vh_statutaire_encad : "--",
        "VH déchargé": data.vh_decharger,
        "VH planifié": data.vh_planifie,
        "VH réalisé": data.vh_realise,
        depassement: data.depassement == 1 ? "Oui" : "Non",
      }));

      // Convert to worksheet and export
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Decharges");
      XLSX.writeFile(
        workbook,
        "Suivi des réalisations_" + this.currentDateTime + ".xlsx"
      );
    },
    filtrer() {
      axios
        .post(
          "/api/permanents/vh",
          {
            depassement: this.filterDepass,
          },
          this.config
        )
        .then((res) => {
          this.allDatas = res.data;
          this.datasLoaded = 1;
        });
    },

    searchVH() {
      axios
        .post(
          "/api/permanents/vh",
          {
            search: this.search,
          },
          this.config
        )
        .then((res) => {
          this.allDatas = res.data;
          this.datasLoaded = 1;
        });
    },
    getResults() {
      axios
        .get("/api/search/prof/" + this.keyword, this.config)
        .then((res) => {
          this.professeur = res.data;

          if (Object.keys(this.professeur).length === 0) {
            this.profNotFound = true;
            this.disableValideBtn = true;
          } else {
            this.profNotFound = false;
            this.disableValideBtn = false;
          }
        })
        .catch((error) => {});
    },
    onChangePageprof(datas) {
      // update page of items
      this.datas = datas;
    },
    reloadprofs() {
      axios.post("/api/permanents/vh", {}, this.config).then((res) => {
        this.allDatas = res.data;
        this.datasLoaded = 1;
      });
    },
    showVH(prof_id) {
      window.location.href = "/administration/vh-permanent-show/" + prof_id;
    },
  },
  beforeMount() {
    axios.post("/api/permanents/vh", {}, this.config).then((res) => {
      this.allDatas = res.data;
      this.datasLoaded = 1;
    });
  },
};
</script>
